export default [
  {
    path: "/print",
    name: "print",
    component: () => import("@/views/print/printReceipt.vue"),
  }
]
